<template>
  <div>
    <van-address-edit
      :area-list="areaList"
      show-set-default
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
      @change-default="onDefault"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import { add_address } from "@/utils/request";
export default {
  data() {
    return {
      areaList,
      is_default:false,
      AddressInfo: null,
      searchResult: [],
    };
  },
  methods: {
    async onSave(e) {
      this.AddressInfo = e;
      //提交地址信息
      await add_address({
        data: {
          token: localStorage.getItem("auth_token"),
          receiver_name: this.AddressInfo.name,
          receiver_phone: this.AddressInfo.tel,
          province: this.AddressInfo.province,
          city: this.AddressInfo.city,
          district: this.AddressInfo.county,
          street: this.AddressInfo.addressDetail,
          is_default: this.is_default ? 1 : 0,
        },
      });
      this.$toast("新增成功");
      setTimeout(() => {
        this.$router.back();
      }, 800);
    },
    onDefault(e) {
      this.is_default = e;
    },
    onChangeDetail() {},
    onDelete() {
      this.$toast("delete");
    },
  },
};
</script>

<style scoped>
::v-deep .van-button--danger {
  background-color: #fa4730 !important;
  border: 1px solid #fa4730 !important;
}
</style>